"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicationImpl = void 0;
const luxon_1 = require("luxon");
const data_1 = require("../data");
/**
 * Extract and concat the iv_fluids and medications from bilan.injections.[iv_fluids || medications]
 */
class MedicationImpl {
    constructor(medic, medicData) {
        this.getHoursMins = (medicData) => luxon_1.DateTime.fromISO(medicData.injected_at)
            .setZone('Europe/Paris')
            .setLocale('fr-fr')
            .toLocaleString(luxon_1.DateTime.TIME_24_SIMPLE)
            .split(':');
        this.injection_id = medic.id;
        this.type = 'injection';
        this.v2 = false;
        this.date = luxon_1.DateTime.fromISO(medicData.injected_at)
            .setZone('Europe/Paris')
            .setLocale('fr-fr');
        this.heure = this.getHoursMins(medicData)[0] ?? null;
        this.minute = this.getHoursMins(medicData)[1] ?? null;
        this.ended_at = null;
        let protocolIdentifier = medic.nursing_protocol_name != null && medic.nursing_protocol_name != ""
            ? `\\${medic.nursing_protocol_name}` : "";
        this.name = `${medicData.name}\\${medic.route_of_administration}${protocolIdentifier}`;
        if ('nursing_protocol_name' in medicData) {
            this.nursing_protocol_name = medicData.nursing_protocol_name ?? null;
        }
        else {
            this.nursing_protocol_name = null;
        }
        this.ampoule_holder_identification = medicData.batch_identification || medicData.ampoule_holder_identification;
        this.quantity = medicData.quantity;
        this.route_of_administration = data_1.ROUTE_OF_ADMINISTRATION.get(medic.route_of_administration) ?? null;
        if ('unit' in medicData) {
            this.unit = medicData.unit === undefined ? data_1.MEDIC_UNITS.get(3) : data_1.MEDIC_UNITS.get(medicData.unit) ?? null;
        }
        else {
            this.unit = data_1.MEDIC_UNITS.get(3);
        }
        this.comment = [null, undefined, ''].includes(medic.comment) ? null : medic.comment;
    }
}
exports.MedicationImpl = MedicationImpl;
